export const number_regex = '\\d*';